import { CSSProperties, ReactNode } from 'react';
import { Box, IconButton, Modal } from '@mui/material';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

type DialogProps = {
  children: ReactNode;
  open: boolean;
  closeAction?: () => void;
  width?: number;
  height?: number;
  style?: CSSProperties;
  isCloseIcon?: boolean;
  isBackDropClickClose?: boolean;
};

const Dialog = ({
  children,
  open,
  closeAction,
  width,
  height,
  style,
  isCloseIcon = true,
  isBackDropClickClose = true,
}: DialogProps) => {
  const handleClose = (_event, reason) => {
    // console.log(reason, 'reason');
    // console.log(!isBackDropClickClose, 'isBackDropClickClose');
    if (reason && reason === 'backdropClick' && !isBackDropClickClose) {
      // console.log(reason, isBackDropClickClose);
      return;
    }
    if (closeAction) {
      closeAction();
    }
  };
  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        display="flex"
        flexDirection="column"
        width={width}
        height={height}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'var(--base-white)',
          boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.02)',
          borderRadius: '6px',
          ...style,
        }}
      >
        <Box display="flex" flexDirection="column" sx={{ height: '100%' }}>
          {isCloseIcon && (
            <Box display="flex" flexDirection="row" justifyContent="flex-end">
              <IconButton onClick={closeAction}>
                <CloseRoundedIcon />
              </IconButton>
            </Box>
          )}
          {children}
        </Box>
      </Box>
    </Modal>
  );
};

export default Dialog;
